<template>
  <div id="sidecart">
    <!-- <div v-else-if="error">
            <pdpError error="true" />
        </div> -->
    <div class="sidecart-wrapper">
      <div class="sidecart-bg" v-on:click="closeCart()"></div>
      <section class="ctpx-sidecart not-empty">
        <!-- 
            =
            =
            = CART HEADER -->
        <div class="ctpx-cart-header">
          <div class="ctpx-cart-header-title">My Cart</div>
          <!-- cart-header-title -->
          <div class="ctpx-cart-header-closer" v-on:click="closeCart()">
            <span>x</span>
          </div>
          <!-- cart-header-closer -->
        </div>
        <!-- ctpx-cart-header -->

        <!-- 
                =
                =
                = CART BODY -->
        <div class="ctpx-cart-body">
          <div class="loading" v-if="cartLoading">
            <loadingAnimation />
          </div>
          <div class="ctpx-cart-body-overflower">
            <!-- ==================== Empty Cart ==================== -->
            <div class="empty-cart" v-if="cart.items.length === 0">
              <div class="row">
                <div
                  class="col text-center"
                  style="margin-bottom: 10px; margin-top: 10px"
                >
                  <h5>Your cart is empty</h5>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
              <div class="row">
                <div class="col">
                  <a
                    href="/collections/all-packs"
                    class="btn btn-black btn-block mb-4"
                    >Shop Packs &amp; Gear</a
                  >
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
              <div class="row">
                <div class="col">
                  <a
                    href="/collections/womens"
                    class="btn btn-black btn-block mb-4"
                    >Shop Women's</a
                  >
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
              <div class="row">
                <div class="col">
                  <a
                    href="/collections/mens"
                    class="btn btn-black btn-block mb-4"
                    >Shop Men's</a
                  >
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
              <div class="row">
                <div class="col">
                  <a
                    href="/collections/sale"
                    class="btn btn-black btn-block mb-4"
                    >Shop Sale</a
                  >
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- empty-cart -->

            <!-- ==================== Cart Progress ==================== -->
            <div class="cart-progress" v-if="cart.items.length !== 0">
              <div class="row">
                <div class="col">
                  <h6
                    class="progress-title"
                    v-if="this.distanceToFreeShipping() / 100 === 0"
                  >
                    You qualify for free shipping!
                  </h6>
                  <h6 class="progress-title" v-else>
                    Spend
                    <span>{{
                      filterPrice(this.distanceToFreeShipping() / 100)
                    }}</span>
                    more to qualify for free shipping
                  </h6>
                  <div
                    class="progress"
                    role="progressbar"
                    aria-label="Basic example"
                    v-bind:aria-valuenow="
                      100 - this.distanceToFreeShipping() / 100
                    "
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      class="progress-bar"
                      :style="`width: ${
                        100 - this.distanceToFreeShipping() / 100
                      }%;`"
                    ></div>
                  </div>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .cart-progress -->

            <!-- ==================== Stuff in Cart ==================== -->
            <div class="stuff-in-cart" v-if="cart.items.length !== 0">
              <div class="cart-contents">
                <div
                  class="cart-prod"
                  v-for="item in cart.items"
                  :key="item.id"
                  :data-id="item.id"
                >
                  <div class="cart-prod-row">
                    <div class="cart-prod-img">
                      <img
                        class="img-fluid"
                        v-if="item.properties?._imgUrl"
                        v-bind:src="item.properties._imgUrl"
                        :alt="item.featured_image.alt"
                      />
                      <img
                        class="img-fluid"
                        v-else
                        v-bind:src="item.featured_image.url"
                        :alt="item.featured_image.alt"
                      />
                    </div>
                    <!-- .cart-prod-img -->
                    <div class="cart-prod-deets">
                      <div class="row">
                        <div class="col-8">
                          <h6>{{ item.product_title }}</h6>
                          <p>{{ item.variant_title }}</p>
                          <!-- <p>{{ }}</p> -->
                        </div>
                        <!-- .col -->
                        <div class="col-4 text-right">
                          <h6
                            v-if="
                              item.line_level_discount_allocations.length > 0
                            "
                            class="original-price"
                          >
                            {{ filterPrice(item.original_line_price / 100) }}
                          </h6>
                          <h6>
                            {{ filterPrice(item.final_line_price / 100) }}
                          </h6>
                          <!-- TODO: we may want to move the discount message to another spot for more space -->
                          <div
                            class="discount-message"
                            v-for="discount in item.line_level_discount_allocations"
                          >
                            <p>
                              {{ discount.discount_application.title }}
                            </p>
                          </div>
                          <!-- TODO: add strike through + discount pricing -->
                          <!-- <div rv-hide="item.total_discount | lt 1" class="original-price" rv-text="item.original_price | money Currency.currentCurrency"></div>
                                                <div class="price" rv-text="item.discounted_price | money Currency.currentCurrency"></div>
                                                <div rv-each-discount="item.discounts" class="discount">
                                                    <p style="line-height: 1; margin: 0;"><small class="ajaxcart-item__discount">{ discount.title }</small></p>
                                                </div> -->
                        </div>
                        <!-- .col -->
                      </div>
                      <!-- .row -->
                      <div class="row d-flex align-items-center">
                        <div class="col-8">
                          <div class="qty">
                            <!-- TODO, increase decrease item count in cart -->
                            <button
                              class="down"
                              v-on:click="
                                updateItem(item.key, item.quantity - 1)
                              "
                            >
                              -
                            </button>
                            <input
                              type="text"
                              v-bind:value="item.quantity"
                              class="value"
                            />
                            <button
                              class="up"
                              :class="{ disabled: isChoiceItem(item) }"
                              v-on:click="
                                updateItem(item.key, item.quantity + 1)
                              "
                              :disabled="isChoiceItem(item)"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <!-- .col -->
                        <div class="col-4 text-right">
                          <!-- TODO: remove line item -->
                          <button
                            class="trash"
                            v-on:click="updateItem(item.key, 0)"
                          >
                            <span class="lid"></span>
                            <span class="can"></span>
                          </button>
                        </div>
                        <!-- .col -->
                      </div>
                      <!-- .row -->
                    </div>
                    <!-- .cart-prod-deets -->
                  </div>
                  <!-- .cart-prod-row -->
                  <div class="cart-prod-row">
                    <div
                      class="cart-prod-message"
                      v-if="
                        item.properties &&
                        Object.keys(item.properties).length !== 0
                      "
                    >
                      <div
                        v-for="(prop, index) in Object.values(item.properties)"
                      >
                        <!-- hide certain props from appearing to the user -->
                        <div v-if="!isHiddenProp(item, index)">
                          {{ prop }}
                        </div>
                      </div>
                    </div>
                    <!-- cart-prod-message -->
                  </div>
                  <!-- .cart-prod-row -->
                </div>
                <!-- cart-prod -->
              </div>
              <!-- cart-contents -->
            </div>
            <!-- stuff-in-cart -->

            <!-- ==================== Cart Widget ==================== -->
            <div v-for="widget of widgets" class="cart-widget">
              <div class="cart-bundler" v-if="!widgetGwpRedeemed(widget)">
                <h3>{{ widget.contentWell.title }}</h3>
                <p class="widget-detail">
                  {{ widget.contentWell.subtitle }}
                </p>
                <!-- ==================== Cart Progress ==================== -->
                <div
                  class="cart-progress widget-progress"
                  v-show="!widgetSpendStatus(widget).thresholdMet"
                >
                  <div class="row">
                    <div class="col">
                      <h6 class="progress-title">
                        Spend
                        <span>{{
                          filterPrice(
                            widgetSpendStatus(widget).distanceToThreshold
                          )
                        }}</span>
                        more to qualify!
                      </h6>
                      <div
                        class="progress"
                        role="progressbar"
                        v-bind:aria-valuenow="
                          widgetSpendStatus(widget).percentToThreshold
                        "
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div
                          class="progress-bar"
                          :style="`width: ${
                            widgetSpendStatus(widget).percentToThreshold
                          }%;`"
                        ></div>
                      </div>
                    </div>
                    <!-- .col -->
                  </div>
                  <!-- .row -->
                </div>
                <div
                  v-show="widgetSpendStatus(widget).thresholdMet"
                  class="bundler-content"
                >
                  <div
                    v-show="
                      !widget.selectedProduct && widget.products.length > 1
                    "
                    class="bundler-swiper"
                  >
                    <swiper
                      :slidesPerView="'auto'"
                      :spaceBetween="10"
                      :loop="widget.products.length > 2"
                      :navigation="true"
                      :modules="modules"
                      class="mySwiper"
                      :breakpoints="{
                        '768': {
                          allowTouchMove: false,
                        },
                      }"
                    >
                      <swiper-slide
                        v-for="product in widget.products"
                        @click="selectWidgetProduct(widget, product)"
                      >
                        <div class="bundler-swiper-prod">
                          <img
                            :src="product.featuredImage"
                            draggable="false"
                            class="img-responsive"
                            width="100"
                            height="100"
                          />
                          <h6>{{ product.title }}</h6>
                        </div>
                        <!-- .bundler-swiper-prod -->
                      </swiper-slide>
                    </swiper>
                  </div>
                  <!-- .bundler-swiper -->
                  <div v-if="widget.selectedProduct" class="bundler-product">
                    <div class="bundler-product-row">
                      <div class="bundler-product-img">
                        <img
                          :src="widget.selectedProduct.selectedColorway.image"
                          draggable="false"
                          class="img-responsive"
                          width="100"
                          height="100"
                        />
                      </div>
                      <!-- .bundler-product-img -->
                      <div class="bundler-product-details">
                        <div class="row">
                          <div class="col-9">
                            <h6>{{ widget.selectedProduct.title }}</h6>
                          </div>
                          <!-- .col-9 -->
                          <div class="col-3 text-right">
                            <div class="price">
                              <s
                                >${{
                                  widget.selectedProduct.selectedColorway.price
                                }}</s
                              >
                              FREE
                            </div>
                          </div>
                          <!-- .col-3 -->
                        </div>
                        <!-- .row -->
                        <div class="row">
                          <div class="col">
                            <swiper
                              :slidesPerView="'auto'"
                              :spaceBetween="5"
                              :loop="false"
                              :navigation="true"
                              :modules="modules"
                              class="mySwiper dot-swiper"
                              :breakpoints="{
                                '768': {
                                  allowTouchMove: false,
                                },
                              }"
                            >
                              <swiper-slide
                                v-for="color in widget.selectedProduct
                                  .colorways"
                                class="dot-slide"
                              >
                                <div
                                  class="dot"
                                  :style="{
                                    backgroundColor:
                                      color.hexValue || '#000000',
                                  }"
                                  :class="[
                                    widget.selectedProduct.selectedColorway
                                      .name == color.name
                                      ? 'active'
                                      : '',
                                    widget.selectedProduct.title
                                      .toLowerCase()
                                      .includes('del d')
                                      ? 'ooak del-dia-dot'
                                      : '',
                                  ]"
                                  @click="
                                    selectWidgetColorway(widget, color, false)
                                  "
                                >
                                  <span></span>
                                </div>
                              </swiper-slide>
                              <swiper-slide
                                v-if="widget.selectedProduct.delDiaVersion"
                                @click="
                                  selectWidgetColorway(
                                    widget,
                                    widget.selectedProduct.delDiaVersion,
                                    true
                                  )
                                "
                              >
                                <div
                                  class="dot ooak del-dia-dot"
                                  :class="
                                    widget.selectedProduct.selectedColorway
                                      .name ==
                                    widget.selectedProduct.delDiaVersion.name
                                      ? 'active'
                                      : ' '
                                  "
                                >
                                  <span></span>
                                </div>
                              </swiper-slide>
                            </swiper>
                          </div>
                          <!-- .col -->
                        </div>
                        <!-- .row -->
                        <div
                          v-if="widget.selectedProduct.showSizes"
                          class="row"
                        >
                          <div class="col">
                            <swiper
                              :slidesPerView="'auto'"
                              :spaceBetween="5"
                              :loop="false"
                              :navigation="true"
                              :modules="modules"
                              class="mySwiper size-swiper"
                              :breakpoints="{
                                '768': {
                                  allowTouchMove: false,
                                },
                              }"
                            >
                              <swiper-slide
                                v-for="size in widget.selectedProduct
                                  .selectedColorway.sizes"
                                class="size-slide"
                              >
                                <div
                                  class="size-tile"
                                  :class="
                                    widget.selectedProduct.selectedVariant
                                      .shopifyVariantId == size.shopifyVariantId
                                      ? 'active'
                                      : ''
                                  "
                                  @click="
                                    widget.selectedProduct.selectedVariant =
                                      size
                                  "
                                >
                                  {{ size.name }}
                                </div>
                              </swiper-slide>
                            </swiper>
                          </div>
                          <!-- .col -->
                        </div>
                        <!-- .row -->
                      </div>
                      <!-- .bundler-product-details -->
                    </div>
                    <!-- .bundler-product-row -->
                    <div class="bundler-product-row">
                      <div
                        class="bundler-product-back"
                        v-show="widget.products.length > 1"
                      >
                        <button
                          @click="widget.selectedProduct = null"
                          class="btn btn-info btn-block"
                        >
                          Back
                        </button>
                      </div>
                      <!-- .bundler-product-back -->
                      <div
                        class="bundler-product-add"
                        :class="{
                          'no-back-button': widget.products.length == 1,
                        }"
                      >
                        <button
                          class="btn btn-black btn-block"
                          @click="
                            addItem(
                              widget.selectedProduct.selectedVariant
                                .shopifyVariantId,
                              1,
                              {
                                _saleStatus:
                                  widget.selectedProduct.selectedColorway
                                    .status,
                              }
                            )
                          "
                        >
                          Add to Cart
                        </button>
                      </div>
                      <!-- .bundler-product-add -->
                    </div>
                    <!-- .bundler-product-row -->
                  </div>
                  <!-- .bundler-product -->
                </div>
              </div>
              <!-- .cart-bundler -->
            </div>
            <!-- cart-widget -->

            <!-- ==================== Cart Widget ==================== -->
            <div class="cart-widget">
              <!-- PUT BUNDLES OR RECOMMENDATIONS HERE -->
            </div>
            <!-- cart-widget -->

            <!-- ==================== Donation Checkbox ==================== -->
            <div class="cart-checkbox donate-wrapper">
              <div class="form-check form-switch">
                <div
                  class="form-check-img"
                  @click="$refs.modalDonate.openModal()"
                >
                  <img
                    src="https://res.cloudinary.com/cotopaxi/image/upload/v1688747712/do-good-cart_rju2t5.png"
                    class="img-fluid"
                    alt="Do Good"
                  />
                </div>
                <div class="form-check-label">
                  <label for="flexCheckIndeterminate"
                    >Donate today and help end extreme poverty in our
                    lifetime.</label
                  >
                  <a
                    class="superscript_link"
                    @click="$refs.modalDonate.openModal()"
                    >See Details</a
                  >
                </div>
                <!-- .form-check-label -->
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  :checked="cartContainsDonationCheckboxItem()"
                  id="flexCheckIndeterminate"
                  v-on:click="toggleDonationItem()"
                />
              </div>
              <!-- .form-check -->
            </div>
            <!-- .cart-checkbox -->
            <!-- ==================== Route Checkbox ==================== -->
            <div
              class="cart-checkbox route-wrapper"
              v-if="cartContainsShippableItem()"
            >
              <div class="form-check form-switch">
                <div class="form-check-img">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0281/7544/files/Route_logo.PNG?37005"
                    class="route-modal-trigger lazy-cart"
                    alt="Route Logo"
                    style="height: auto; width: 40px"
                  />
                </div>
                <!-- .form-check-img -->
                <div class="form-check-label">
                  <label for="route_checkbox"
                    >Add Route shipping protection for $1.15.</label
                  >
                  <a
                    class="superscript_link route-modal-trigger"
                    @click="$refs.modalRoute.openModal()"
                    >See Details</a
                  >
                </div>
                <!-- .form-check-label -->
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  :checked="cartContainsRouteInsuranceItem()"
                  id="route_checkbox"
                  v-on:click="toggleRouteItem()"
                />
              </div>
              <!-- .form-check -->
            </div>
            <!-- .cart-checkbox -->

            <!-- <div
              class="cart-box ecocart-wrapper"
            >
                <div class="box-img">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/EcoCartLogo.png?v=1711576270"
                    class="route-modal-trigger lazy-cart"
                    alt="EcoCart Logo"
                    style="height: auto; width: 40px"
                  />
                </div>
                <div class="box-label">Offset your order at checkout with
                  <a
                    class="superscript_link route-modal-trigger"
                    @click="$refs.modalRoute.openModal()"
                    >EcoCart</a
                  >
                </div>
            </div> -->
            <!-- .cart-checkbox -->

            <!-- ==================== Guaranteed for Good Box ==================== -->
            <!-- ==================== GFG Box ==================== -->
            <a
              href="/pages/guaranteed-for-good"
              alt="Guaranteed for Good™"
              target="_blank"
              class="guaranteed-for-good-box d-flex flex-column align-items-center"
            >
              <h3 class="text-center" style="margin-bottom: 20px">
                Guaranteed for Good™
              </h3>
              <div class="row icon-row flex-nowrap mx-2">
                <div class="col-4 flex-column text-center">
                  <img
                    class="img-icon"
                    src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Free-Returns-Exchanges.svg"
                    loading="lazy"
                    width="30px"
                    height="30px"
                  />
                  <span class="text-center">Easy Returns and Exchanges</span>
                </div>
                <!-- .col-4 -->
                <div class="col-4 flex-column text-center">
                  <img
                    class="img-icon"
                    src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Lifetime-Warranty.svg"
                    loading="lazy"
                    width="30px"
                    height="30px"
                  />
                  <span class="text-center">Lifetime Warranty + Repairs</span>
                </div>
                <!-- .col-4 -->
                <div class="col-4 flex-column text-center">
                  <img
                    class="img-icon"
                    src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-RePurposed.svg"
                    loading="lazy"
                    width="30px"
                    height="30px"
                  />
                  <span class="text-center">Trade-In for Gift Cards</span>
                </div>
                <!-- .col-4 -->
              </div>
              <!-- .row --> </a
            ><!-- guaranteed-for-good-box -->
          </div>
          <!-- ctpx-cart-body-overflower -->
        </div>
        <!-- ctpx-cart-body -->

        <!-- 
            =
            =
            = CART FOOTER -->
        <div class="ctpx-cart-footer">
          <!-- <div
            class="ctpx-cart-footer-ecocart-widget"
            id="ecocart-widget"
          ></div> -->
          <!-- ctpx-cart-footer-checkout -->
          <div class="ctpx-cart-footer-checkout">
            <div class="row">
              <div class="col">
                <div class="cart-count">
                  <!-- .cart-count -->
                  {{ cart.item_count }}
                  <span v-if="cart.item_count == 1">Item</span
                  ><span v-else>Items</span>
                </div>
              </div>
              <!-- .col -->
              <div class="col">
                <div class="cart-total">
                  {{ filterPrice(cart.total_price / 100) }}
                </div>
                <!-- .cart-total -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row -->
            <!-- move the user to the checkout URL -->
            <!-- if we are on the cart page, have the side cart move to checkout, else move to the cart page. -->
            <a :href="checkoutButtonUrl">
              <button class="btn btn-blue btn-block">Check Out</button>
            </a>
            <p>
              <small
                >Promotions, shipping & taxes calculated at checkout.</small
              >
            </p>
          </div>
          <!-- ctpx-cart-footer-checkout -->
        </div>
        <!-- ctpx-cart-footer -->
      </section>
    </div>
  </div>

  <!-- .lighboxes -->
  <modal ref="modalDonate">
    <template v-slot:header>
      <h1>Donate Today</h1>
    </template>
    <template v-slot:body>
      <p>
        Global Uprising, PBC dba Cotopaxi ("Cotopaxi") distributes 100% of the
        monetary donations that it receives from its customers to the Cotopaxi
        Foundation on a monthly basis.
      </p>
      <p><strong>What is the Cotopaxi Foundation?</strong></p>
      <p>
        The Cotopaxi Foundation is a Utah-based private 501c3 nonprofit
        organization.
      </p>
      <p>
        Giving is core to the Cotopaxi model. The foundation is the next step in
        terms of doing more good. 1% of our annual revenue goes to the Cotopaxi
        Foundation, which aims to boost our grantmaking, democratize our impact,
        and help us make a bigger difference in the communities we touch.
      </p>
      <p>
        Every time you purchase one of our products, you’re contributing to the
        Cotopaxi Foundation. But we encourage you to be part of Doing Good by
        giving directly to the foundation. However you support our efforts, your
        contribution is making a difference.
      </p>
      <p>
        We are not able to provide tax deductible receipts for our customers at
        this time. Cotopaxi is exploring how to modify this process in the
        future, and will post updates here on our website.
      </p>
    </template>
  </modal>

  <modal ref="modalGFG">
    <template v-slot:header>
      <h1>Guaranteed for Good™</h1>
    </template>
    <template v-slot:body>
      <p>
        Truly sustainable design includes a backup plan. If there's a problem
        with your gear, we'll happily repair it, replace it, credit your return,
        or reward you for trading it in.
      </p>
    </template>
  </modal>

  <!-- route modal -->
  <modal ref="modalRoute">
    <template v-slot:body>
      <div id="route-info" class="route-modal">
        <div class="route-modal-box">
          <img
            class="background lazy-route"
            src="https://cdn.routeapp.io/route-widget/images/LightboxBackground.svg"
          />
          <img
            class="route-line lazy-route"
            src="https://cdn.routeapp.io/route-widget/images/RouteLine.png"
          />
          <div class="route-modal-header">
            <img
              class="route-rm-route-logo lazy-route"
              src="https://cdn.routeapp.io/route-widget/images/RouteLogoWhite.svg"
            />
            <img
              class="route-rm-route-logo-color lazy-route"
              src="https://cdn.routeapp.io/route-widget/images/RouteLogoKiona.png"
            />
            <div class="route-rm-secure-with">
              Secure your shipment and easily <br />resolve order issues with
              one tap.
            </div>
            <img
              class="route-rm-close-modal lazy-route"
              src="https://cdn.routeapp.io/route-widget/images/CloseIcon.svg"
            />
          </div>
          <div class="route-modal-content">
            <div class="icon-box1">
              <span class="route-rm-icon-box1">
                <img
                  class="route-rm-icon-box-image lazy-route"
                  src="https://cdn.routeapp.io/route-widget/images/LBBox_1.svg"
                  alt="Secured your shipment"
                />
              </span>
              <div class="route-rm-text1">
                Protect orders from loss,<br />
                damage, or theft.
              </div>
            </div>
            <div class="icon-box2">
              <span class="route-rm-icon-box2">
                <img
                  class="route-rm-icon-box-image lazy-route"
                  src="https://cdn.routeapp.io/route-widget/images/Instant_Protection.svg"
                  alt="Instantly insured"
                />
              </span>
              <div class="route-rm-text2">
                Backed by SEG Insurance<br />
                Ltd. through Route.
              </div>
            </div>
            <div class="icon-box3">
              <span class="route-rm-icon-box3">
                <img
                  class="route-rm-icon-box-image lazy-route"
                  src="https://cdn.routeapp.io/route-widget/images/LBBox_3.svg"
                  alt="One click claims"
                />
              </span>
              <div class="route-rm-text3">
                Refunds or reorders<br />
                in just a few clicks.
              </div>
            </div>
          </div>
          <div class="route-modal-footer">
            <div class="rm-footer-1">
              <div class="route-rm-terms">
                This optional protection is offered to you solely in order to
                effectuate the shipment of your package(s). Route is the named
                assured on the Route Policy of which your shipment will be
                protected on. The cost of adding your shipment to the Route
                Policy includes compensation paid to Safe Order Solutions, LLC
                (a licensed insurance agency affiliate of Route), for making
                this protection available.
              </div>
            </div>
            <div class="rm-footer-2">
              <div class="route-rm-copyright">Route App © 2019 Route App</div>
              <div class="route-rm-user-privacy">
                <a
                  class="route-rm-user-privacy-text"
                  href="https://www.routeapp.io/user-privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  User Privacy
                </a>
              </div>
              <div class="route-rm-terms-of-use">
                <a
                  class="route-rm-terms-of-use-text"
                  href="https://www.routeapp.io/user-terms-of-use/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  User Terms of Use
                </a>
              </div>
              <div class="route-rm-lloyds-container">
                Backed by SEG Insurance ltd.
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script src="./ctrl-sidecart.js">
// import PdpErr from './pdp-error/pdp-err.vue';
</script>
